import api from '../services/api';

const Patrocinador = {
  create : async function (data) {
    return await api.post('patrocinadores', data)
    .then(response=>response)
    .catch(error=>error);
  },

  // Habilita ('Ativo') ou desabilita ('Inativo') sem apagar (so administrador).
  alterarStatus : async function (id, status) {
    return await api.patch(`patrocinadores/id/${id}/status`, { status })
    .then(response=>response)
    .catch(error=>error);
  },

  delete : async function (patrocinador_id) {
    return await api.delete(`patrocinadores/id/${patrocinador_id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  // Um item pelo id (usado pelas páginas de edição do painel administrativo).
  findById : async function (id) {
    return await api.get(`patrocinadores/id/${id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  // Listagem paginada com busca opcional (usada pelas listas do painel administrativo).
  listar : async function (page = 1, limit = 10, busca = '') {
    const termo = (busca || '').trim();
    const url = termo
      ? `patrocinadores/data/${encodeURIComponent(termo)}/${page}/${limit}?todos=1`
      : `patrocinadores/all/${page}/${limit}?todos=1`;
    return await api.get(url)
    .then(response=>response)
    .catch(error=>error);
  },
  findAll : async function () {
    return await api.get('patrocinadores/all/1/50')
    .then(response=>response)
    .catch(error=>error);
  },

  findSearch : async function (data) {
    return await api.get(`patrocinadores/data/${data}/1/50`)
    .then(response=>response)
    .catch(error=>error);
  }
}

export default Patrocinador;
